module.exports = __webpack_public_path__ + "img/flag_en.cf05a44e.svg";